import React, { memo } from 'react'
import { Box, Grid } from '@mui/material'
import Image from '@v4/components/common/Image'
import EditableHTML from '@v4/components/common/EditableHTML'
import ActionButton from '@v4/components/common/Buttons/ActionButton'
import PropTypes from 'prop-types'
import PageMetaData from '@v4/utils/data/PageMetaData'
import EditableContainer from '@v4/components/common/EditableContainer'
import { CONTENT_WIDTH } from './Banner9_10.const'
// eslint-disable-next-line camelcase
import { useBanner9_10 } from './Banner9_10.hooks'

// eslint-disable-next-line camelcase
const Banner9_10 = props => {
	const [
		{
			classes,
			cx,
			contentWidth,
			textShadow,
			mobileImage,
			desktopBgImage,
			withDesktopBgImage,
			withMobileBgImage,
			withMobileImage,
			sx,
			sxWhite,

			text,
			textConfig,
			textKey,
			textEditable,

			buttonText,
			buttonLink,
			buttonAction,
			buttonTextEditable,
			buttonTextConfig,
			buttonTextKey,

			extraShortcuts,
		},
		{
			handleDesktopImageClick,
			handleMobileImageClick,

			handleTextClick,
			handleTextChange,

			handleButtonClick,
			handleButtonTextChange,
		},
	] = useBanner9_10(props)

	return (
		<>
			{withDesktopBgImage && (
				<Image
					className={cx(classes.background, classes.bgDesktop, 'banner9_10-bg-image')}
					metaData={desktopBgImage}
					onClick={handleDesktopImageClick}
					isBackground
				/>
			)}
			{withMobileBgImage && (
				<Image
					className={cx(classes.background, classes.bgMobile, 'banner9_10-bg-image')}
					metaData={mobileImage}
					onClick={handleMobileImageClick}
					isBackground
				/>
			)}
			<Grid className={cx(classes.root, 'banner9_10-root')} container>
				<Grid
					className={cx(classes.grid, 'banner9_10-grid')}
					size={{
						xs: 12,
						sm: 12,
						md: CONTENT_WIDTH[contentWidth],
					}}
				>
					<div className={cx(classes.content, 'banner9_10-content')}>
						<EditableContainer
							visible={!!text}
							white={withDesktopBgImage}
							sx={sxWhite}
							fieldConfig={textConfig}
							onAdd={handleTextChange}
							editable={textEditable}
						>
							<EditableHTML
								key={textKey}
								className={cx(classes.text, 'banner9_10-text')}
								gutterBottom
								white={withDesktopBgImage}
								html={text}
								onClick={handleTextClick}
								extraShortcuts={extraShortcuts}
								onChange={handleTextChange}
								editable={textEditable}
								shadow={withDesktopBgImage}
								textShadow={textShadow}
								sx={sx}
							/>
						</EditableContainer>
						<EditableContainer
							visible={!!buttonText}
							white={withDesktopBgImage}
							fieldConfig={buttonTextConfig}
							onAdd={handleButtonTextChange}
							editable={buttonTextEditable}
							label="Button"
							wrapper={({ children }) => (
								<Box className={cx(classes.buttonWrap, 'banner9_10-button-wrapper')}>{children}</Box>
							)}
							sx={sxWhite}
						>
							<ActionButton
								key={buttonTextKey}
								action={buttonAction}
								href={buttonLink}
								className={cx(classes.button, 'banner9_10-button')}
								onClick={handleButtonClick}
								editable={buttonTextEditable}
								onChange={handleButtonTextChange}
							>
								{buttonText}
							</ActionButton>
						</EditableContainer>
					</div>
				</Grid>
				{withMobileImage && (
					<Grid
						className={classes.mobileImage}
						size={{
							xs: 12,
							sm: 12,
							md: 5,
						}}
					>
						<Box>
							<Image
								className={cx(classes.image, 'banner9_10-mobile-image')}
								metaData={mobileImage}
								onClick={handleMobileImageClick}
							/>
						</Box>
					</Grid>
				)}
			</Grid>
		</>
	)
}

Banner9_10.propTypes = {
	backgroundImage: PropTypes.instanceOf(PageMetaData),
	buttonAction: PropTypes.instanceOf(PageMetaData),
	buttonLink: PropTypes.instanceOf(PageMetaData),
	buttonText: PropTypes.instanceOf(PageMetaData),
	buttonTextKey: PropTypes.instanceOf(PageMetaData),
	contentWidth: PropTypes.instanceOf(PageMetaData),
	text: PropTypes.instanceOf(PageMetaData),
	opacity: PropTypes.instanceOf(PageMetaData),
	textConfig: PropTypes.instanceOf(PageMetaData),
	mobileAlignment: PropTypes.instanceOf(PageMetaData),
	mobileImagePosition: PropTypes.instanceOf(PageMetaData),
	mobileImage: PropTypes.instanceOf(PageMetaData),
	mobileButtonWidth: PropTypes.instanceOf(PageMetaData),
	overrideXsMargins: PropTypes.instanceOf(PageMetaData),
}

export default memo(Banner9_10)
